import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined); // undefined=loading, null=not auth, obj=auth
  const [school, setSchool] = useState(null);

  // Pull school config (operating_mode + feature toggles) once we know who the user is.
  // Drives the parent / student / admin nav visibility.
  const loadSchool = async (u) => {
    if (!u || u.role === "super_admin" || !u.school_id) { setSchool(null); return null; }
    try {
      const { data } = await api.get("/schools/me");
      setSchool(data);
      return data;
    } catch {
      setSchool(null);
      return null;
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("grubpe_token");
    if (!token) { setUser(null); return; }
    api.get("/auth/me")
      .then((r) => { setUser(r.data); loadSchool(r.data); })
      .catch(() => { localStorage.removeItem("grubpe_token"); setUser(null); });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("grubpe_token", data.token);
    setUser(data.user);
    await loadSchool(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("grubpe_token", data.token);
    setUser(data.user);
    await loadSchool(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("grubpe_token");
    setUser(null);
    setSchool(null);
  };

  const refresh = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    await loadSchool(data);
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, school, setUser, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
